<template>
  <Page class="queryView">
    <div class="queryView-main">
      <div style="display:flex;width:100%">
        <a-form class="flex-form"
                style="flex: 1"
                layout="inline"
                :form="form"
                :colon="false">
          <div class="grid grid-cols-2 xl:grid-cols-3">
            <a-form-item label="所属城市">
              <a-input v-decorator="['region']"></a-input>
            </a-form-item>
            <a-form-item label="项目名称">
              <a-input v-decorator="['name']"></a-input>
            </a-form-item>
          </div>
        </a-form>
        <div style="text-align: right">
          <a-button class="app-btn"
                    type="default"
                    @click="handleAdd">添加项目</a-button>
        </div>
      </div>

      <a-table class="mt-5"
               :row-key="
          (record, index) => {
            return index
          }
        "
               bordered
               :loading="tableLoading"
               :columns="tableColumns"
               :dataSource="dataSource"
               @change="handleTableChange$qv"
               :scroll="{ x: 1400 }"
               :pagination="{
          current: pageNumber,
          pageSize: limit,
          total: countTotal,
          showSizeChanger: true,
          showQuickJumper: true,
        }" />
    </div>
    <a-modal :visible="addGuideType"
             :title="modalTitle"
             @ok="submit"
             width="700px"
             @cancel="handleCancel">
      <div>
        <a-form :form="addForm">
          <a-form-item label="所属区域">
            <a-input v-decorator="['region', { rules: [{ required: true, message: '请输入所属区域' }] }]" />
          </a-form-item>
          <a-form-item label="项目名称">
            <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入项目名称' }] }]" />
          </a-form-item>
        </a-form>
      </div>
    </a-modal>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'

export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '10%',
        align: 'center',
        customRender: (text, row, index) => {
          return <span>{this.limit * (this.pageNumber - 1) + (index + 1)} </span>
        },
      },
      {
        title: '所属区域',
        align: 'center',
        dataIndex: 'region',
      },
      {
        title: '项目名称',
        align: 'center',
        dataIndex: 'name',
      },
      {
        title: '操作',
        width: '12%',
        align: 'center',
        customRender: (text, row) => {
          return (
            <div class="flex justify-center gap-5 text-primary-500">
              <a
                class="text-primary-500"
                onClick={() => {
                  this.checkRow(row, 'edit')
                }}
              >
                修改
              </a>
              <a
                onClick={() => {
                  this.handleDel(row)
                }}
              >
                删除
              </a>
            </div>
          )
        },
      },
    ]
    return {
      modalTitle: '添加项目',
      // labelCol: { style: { width: '100px' } },
      pageNumber: 1,
      limit: 10,
      countTotal: 0,
      id: null,
      tableLoading: false,
      addGuideType: false,
      tableColumns: tableColumns,
      dataSource: [],
      form: this.$form.createForm(this),
      addForm: this.$form.createForm(this),
      typeList: [
        { label: 'API', value: 1 },
        { label: 'H5', value: 2 },
        { label: '小程序', value: 3 },
      ],
    }
  },
  components: {
    Page,
  },
  async mounted() {
    this.doQuery()
  },
  methods: {
    submit() {
      this.addForm.validateFields(async (err, values) => {
        if (!err) {
          const params = values
          params.id = this.id
          let res = null
          if (this.modalTitle == '添加项目') {
            res = await this.$axios.post('/guide/admin/cashReceivedItems/add', params)
          } else {
            res = await this.$axios.put('/guide/admin/cashReceivedItems/edit', params)
          }
          console.info('success', res)
          if (res && res.success) {
            this.addGuideType = false
            this.doQuery()
          }
        }
      })
    },
    handleCancel() {
      this.addGuideType = false
    },
    async doQuery(_page = this.pageNumber, _limit = this.limit) {
      this.tableLoading = true
      const res = await this.$axios.get('/guide/admin/cashReceivedItems/getList', {
        params: {
          page: _page,
          limit: _limit,
          ...this.form.getFieldsValue(),
        },
      })
      this.countTotal = Number(res.count)
      this.dataSource = res.data
      this.tableLoading = false
    },
    async handleAdd() {
      this.modalTitle = '添加项目'
      this.id = null
      this.addForm.resetFields()
      this.addGuideType = true
    },
    async checkRow(row) {
      this.modalTitle = '编辑项目'
      this.id = row.id
      this.$nextTick(() => {
        this.safeSetFieldsValue$t(this.addForm, row)
      })
      this.addGuideType = true
    },
    async handleDel(row) {
      this.$confirm({
        title: '删除确认',
        content: '您确认删除当前项目?',
        onOk: async () => {
          const res = await this.$axios.delete(`/guide/admin/cashReceivedItems/delete/${row.id}`)
          if (res.success) {
            this.$message.success('删除成功')
            this.doQuery()
          }
        },
        onCancel: () => {
          // reject(new Error('E_CANCEL'))
        },
      })
    },
  },
}
</script>

<style lang="less" scoped></style>
